import React, { useState } from "react";
import PageContent from "../shared/PageContent/PageContent";
import { Stack } from "@mantine/core";
import LeaderboardTab from "./LeaderboardTab";
import IncentivesTab from "./IncentivesTab";
import PrizeLockerTab from "./PrizeLockerTab";
import "./PerformancePage.css";

function PerformancePage() {
  const [selectedTab, setSelectedTab] = useState("leaderboard");

  return (
    <PageContent
      customHeader={
        <div className="performance-page-custom-header">
          <div className="performance-page-header-left">
            <h1 className="performance-page-main-title">Performance</h1>
            <div className="performance-page-nav-tabs">
              <button
                className={`performance-page-nav-tab ${
                  selectedTab === "leaderboard" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("leaderboard")}
              >
                Leaderboard
              </button>
              <button
                className={`performance-page-nav-tab ${
                  selectedTab === "incentives" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("incentives")}
              >
                Incentives
              </button>
              <button
                className={`performance-page-nav-tab ${
                  selectedTab === "prize_locker" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("prize_locker")}
              >
                Prize Locker
              </button>
            </div>
          </div>
        </div>
      }
    >
      <Stack spacing="lg">
        {selectedTab === "leaderboard" && <LeaderboardTab />}
        {selectedTab === "incentives" && <IncentivesTab />}
        {selectedTab === "prize_locker" && <PrizeLockerTab />}
      </Stack>
    </PageContent>
  );
}

export default PerformancePage;
